/** Ghost preview opacity while dragging a template (US-13: a 60% ghost). */
export const TEMPLATE_DRAG_GHOST_OPACITY = 0.6

/** Thumbnail opacity while its template is being dragged. */
export const TEMPLATE_TRAY_DRAGGING_THUMB_OPACITY = 0.6

/** Keyboard placement: a template has fixed coordinates, so this only feeds the shared session. */
export const TEMPLATE_KEYBOARD_DEFAULT_CENTER_FRACTION = 0.5
